import template from './ActivityGrid.html';

export default {
	template,
	props: [
		'type'
	],
	computed: {
		remoteMethod() {
			let map = {
				pageviews: 'Stats.getPageViews',
				sessions: 'Stats.getSessions',
			};
			return map[this.type];
		},
		reloadWatcher() {
			return this.json.encode(this.app.query) + '*' + this.app.tz + '*' + this.app.owner;
		}
	},
	methods: {
		getShortUrl(url) {
			return url.replace(/^https?:\/\/.*?\//i, '/');
		},
		getDurationTitle(row) {
			let total = this.time.getHumanTime(row.time);
			let active = this.time.getHumanTime(row.activeTime);

			if (row.time === row.activeTime) return `Time: ${total}`;

			return `Total time: ${total}\nActive time: ${active}`;
		},
		getTime(row) {
			let now = moment();
			let m = moment(row.datetime);

			let format;
			if (now.format('YYYY-MM-DD') === m.format('YYYY-MM-DD')) {
				format = 'HH:mm';
			} else if (now.format('YYYY') === m.format('YYYY')) {
				format = 'D MMM, HH:mm';
			} else {
				format = 'YYYY, D MMM, HH:mm';
			}

			return m.format(format);
		},
		getRecordingUrl(row) {
			let url = '/recording/' + row.domain + '/' + row.sessionId;
			if (this.type === 'pageviews') {
				url += '/' + row.id;
			}
			return url;
		},
		async getSearchQueries(row) {
			console.log(row.sessionId);
			let res = await this.http.get('SearchConsole.getSearchQueries', row.sessionId);
			console.log(res.map(row => row.query));
		}
	}
};